import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
];

export const LanguageSelector = ({ variant = 'default', className = '' }) => {
  const { i18n } = useTranslation();

  const handleChange = (value) => {
    i18n.changeLanguage(value);
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  if (variant === 'minimal') {
    return (
      <Select value={i18n.language} onValueChange={handleChange}>
        <SelectTrigger className={`w-auto gap-2 bg-transparent border-white/10 text-gray-400 hover:text-white ${className}`}>
          <Globe size={16} />
          <SelectValue>{currentLang.flag}</SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-[#1a1a1b] border-white/10">
          {languages.map((lang) => (
            <SelectItem 
              key={lang.code} 
              value={lang.code}
              className="text-gray-300 hover:text-white focus:text-white focus:bg-white/10"
            >
              <span className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={i18n.language} onValueChange={handleChange}>
      <SelectTrigger className={`w-[160px] bg-white/5 border-white/10 text-gray-300 ${className}`}>
        <Globe size={16} className="mr-2" />
        <SelectValue>{currentLang.name}</SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-[#1a1a1b] border-white/10">
        {languages.map((lang) => (
          <SelectItem 
            key={lang.code} 
            value={lang.code}
            className="text-gray-300 hover:text-white focus:text-white focus:bg-white/10"
          >
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
